import { Alert, AlertIcon, Text, type AlertProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { EspdRequirement } from "../../utils/computeEspdRequirement";

interface Props {
  requirement: EspdRequirement;
  mb?: AlertProps["mb"];
}

export const EspdThresholdBanner = ({ requirement, mb = "3" }: Props) => {
  const { t } = useTranslation();
  return (
    <Alert
      status={requirement.required === true ? "success" : "info"}
      variant="left-accent"
      borderRadius="md"
      mb={mb}
    >
      <AlertIcon />
      <Text fontSize="sm">
        {requirement.required === "unknown"
          ? t("ESPD status is unknown: provide an estimated value to determine whether ESPD is legally required.")
          : requirement.required
          ? t("An ESPD form will be attached upon publication. The estimated value ({{value}}) exceeds the EEA threshold, so ESPD is legally required for this notice.", { value: requirement.value })
          : t("The estimated value ({{value}}) is below the EEA threshold — ESPD is not legally required, but may be attached voluntarily.", { value: requirement.value })}
      </Text>
    </Alert>
  );
};
